var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"color":"cmf_darkgrey","size":"16"}},[_vm._v("$close")])}
var staticRenderFns = []

export { render, staticRenderFns }